<div style="margin-left: 0px;" class="content-wrapper" id="content-wrapper">
  <section class="content-header">
    <h1>
      Hora Extra
    </h1>
    <ol class="breadcrumb">
      <li><i class="fa fa-dashboard"></i>&nbsp;&nbsp;&nbsp;Home</li>
      <li>Solicitação</li>
      <li class="active">Hora Extra</li>
    </ol>
  </section>

  <!-- modalp popup ends -->
  <section class="content">
    <form id="formulario">
      <div style="margin-left: 0px;">
        <div class="box box-primary">
          <div class="box-body">
            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label>Data</label>
                  <div class="input-group date">
                    <input type="text" mask="00/00/0000" autocomplete="off" class="form-control pull-right" id="txtData" name="txtData"
                      placeholder="dd/mm/yyyy">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-5">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Horário Inicial</label>
                      <input type="time"  class="form-control" id="txtHoraInicial" name="txtHoraInicial"
                        placeholder="00:00">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Horário Final</label>
                      <input type="time" class="form-control" id="txtHoraFinal" name="txtHoraFinal"
                        placeholder="00:00">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" style="padding-top: 15px;">
              <div class="col-md-3">
                <div class="form-group">
                  <label>Motivo</label>
                  <input type="text" class="form-control" id="txtMotivo" name="txtMotivo" placeholder="Motivo">
                </div>
              </div>
              <div class="col-md-5">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <div class="row">
                        <div class="col-md-12" style="text-align: center;">
                          <label>Café da Manhã?</label>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12" style="text-align: center;">
                          <input type="checkbox" id="checkCafe">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <div class="row">
                        <div class="col-md-12" style="text-align: center;">
                          <label>Refeição?</label>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12" style="text-align: center;">
                          <input name="alimentacao" id="radioRefeicao" type="radio">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <div class="row">
                        <div class="col-md-12" style="text-align: center;">
                          <label>Marmitex?</label>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12" style="text-align: center;">
                          <input name="alimentacao" id="radioMarmitex" type="radio">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
          </div>

          <div class="box-footer">
            <table border=0 width="100%">
              <tr width="100%">
                <td align="left"><button type="reset" (click)="clearInputvalues()"
                    class="btn btn-default">Limpar</button>
                </td>
                <td align="center"><span id="spanErro" name="spanErro" class="error" style="font-weight: bold;"></span>
                </td>
                <td align="right">
                  <input value="Solicitar" readonly="readonly" (click)="solicitar()" class="btn btn-info pull-right btn-margin" />
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="box box-body">
        <div style="overflow-y: auto;">
          <div style="width: 99%; padding-left: 15px;">
            <table #grid style="width: 100% !important;" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th style="width: 15% !important">Data</th>
                  <th style="width: 15% !important">Horário Inicial</th>
                  <th style="width: 15% !important">Horário Final</th>
                  <th style="width: 15% !important">Motivo</th>
                  <th style="width: 15% !important">Café da Manhã?</th>
                  <th style="width: 15% !important">Refeição?</th>
                  <th style="width: 15% !important">Marmitex?</th>
                  <th style="width: 15% !important">Data da Solicitação</th>
                  <th style="width: 2% !important"></th>
                </tr>
              </thead>
            </table>
          </div>
        </div>
      </div>
    </form>
  </section>

  <div class="control-sidebar-bg"></div>
</div>

<div class="modal fade" id="modalConvocacao" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title"><b>Convocar Funcionários</b></h4><br>
      </div>
      <div class="modal-body">
        <form id="formularioConvocacao">
          <div style="overflow-y: auto; padding-left: 10px; padding-right: 10px;">
            <div style="width: 99%;">
              <table #gridModalConvocacao tyle="width: 100% !important;" class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th style="text-align: center;"><input id="checkAll" type="checkbox"
                        (click)="checkAllConvocacao()" /></th>
                        <th style="text-align: center;">Matrícula</th>
                    <th style="text-align: center;">CPF</th>
                    <th style="text-align: center;">Nome</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <input id="convocarEquipe" name="convocarEquipe" value="Convocar" (click)="convocarEquipe()"
          class="btn btn-info pull-right btn-margin" />
        <button type="button" class="btn btn-default pull-left" data-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>